import { AppointmentType } from '../../../../../../graphql';

export interface CancelAppointmentTextIds {
  titleId: string;
  descriptionId: string;
}

export const getCancelAppointmentTextIds = (
  appointmentType?: AppointmentType | null,
): CancelAppointmentTextIds => {
  switch (appointmentType) {
    case AppointmentType.controlVisit:
      return {
        titleId: 'appointmentCancel.title.controlVisit',
        descriptionId: 'appointmentCancel.description.controlVisit',
      };
    case AppointmentType.aec:
      return {
        titleId: 'appointmentCancel.title.aec',
        descriptionId: 'appointmentCancel.description.aec',
      };
    default:
      return {
        titleId: 'appointmentCancel.title',
        descriptionId: 'appointmentCancel.description',
      };
  }
};
